module.exports = __webpack_public_path__ + "static/media/cq_convalida b.fc79e95e.svg";